/**
 * News Archive
 */

import React, { useState } from "react"
import parse from "html-react-parser"
import { kebabCase } from "lodash"
import { useStaticQuery, graphql, Link } from "gatsby"
import { RadioGroup } from "@headlessui/react"
import { Disclosure } from "@headlessui/react"
import CopyLinkButton from "./copy-link-button"
import NewsCard from "./news-card"
import { FaChevronDown } from "react-icons/fa"

const NewsArchive = ({ props }) => {
  const data = useStaticQuery(graphql`
    {
      allWpCategory(
        filter: {parentId: {eq: null}, name: {nin: ["Uncategorized", "Featured"]}}
      ) {
        nodes {
          ...Category
        }
      }
      allWpPost(sort: {date: DESC}) {
        nodes {
          ...NewsCard
        }
      }
    }
  `)
  let posts = data?.allWpPost?.nodes
  const type = props?.type
  const link = props?.link
  posts = type === "featured" ? posts.slice(0, 4) : posts
  const categoryAll = [{ slug: "all", name: "All", parentId: 0 }]
  const categories = categoryAll.concat(data?.allWpCategory?.nodes)
  const [selected, setSelected] = useState(categories[0].slug)
  function checkCategory(postCategory) {
    return postCategory.slug === selected
  }
  return (
    <section
      key={props}
      className="section relative transparent p-section-half"
    >
      <div className="container grid gap-8 2xl:gap-12">
        <div className="">
          <div className="group-copy-link group">
            {props.heading ? (
              <>
                <h2
                  className="anchor-heading mb-4 max-w-2xl"
                  id={kebabCase(props.heading).replace(/[0-9]/g, "")}
                >
                  {props.heading}
                </h2>
                <CopyLinkButton heading={props.heading} />
              </>
            ) : props.includeInStickyMenu?.menuTitle ? (
              <div id={kebabCase(props.includeInStickyMenu.menuTitle) || ""}>
                <CopyLinkButton heading={props.includeInStickyMenu.menuTitle} />
              </div>
            ) : null}
          </div>
          {props.leadContent ? (
            <div
              className={`parsed-content max-w-2xl ${
                props.includeIcons ? "-mb-4" : ""
              }`}
            >
              {parse(props.leadContent)}
            </div>
          ) : null}
        </div>
        <div
          className={`${
            type !== "featured"
              ? "grid md:grid-cols-3 lg:grid-cols-4 gap-8 lg:gap-8 2xl:gap-12 grid-flow-row-dense"
              : ""
          }`}
        >
          {type !== "featured" ? (
            <div className="rounded bg-gray-100 p-4 xl:p-6 relative md:col-start-3 lg:col-start-4">
              <div className="">
                <RadioGroup value={selected} onChange={setSelected}>
                  <RadioGroup.Label className="sr-only">
                    Category
                  </RadioGroup.Label>
                  <div className="space-y-3">
                    {categories.map(category => {
                      return (
                        <>
                          {category.wpChildren?.nodes ? (
                            <Disclosure>
                              {({ open }) => (
                                <>
                                  <Disclosure.Button
                                    className={`hover-grow 
                                          ${
                                            open
                                              ? "bg-blue-700 text-white"
                                              : "bg-white "
                                          }
                                            relative flex items-center group justify-between w-full cursor-pointer rounded-lg leading-tight px-4 py-3 mb-1 shadow-md focus:outline-none hover-grow`}
                                  >
                                    {category.name}

                                    <FaChevronDown
                                      className={`inline-block group-hover:text-opacity-100 text-opacity-70 ${
                                        open
                                          ? "rotate-180 transform text-white"
                                          : "text-gray-900"
                                      } text-lg`}
                                    />
                                  </Disclosure.Button>
                                  <Disclosure.Panel className="">
                                    {RadioGroupOption(
                                      category.wpChildren?.nodes,
                                      true
                                    )}
                                  </Disclosure.Panel>
                                </>
                              )}
                            </Disclosure>
                          ) : (
                            <>{RadioGroupOption([category])}</>
                          )}
                        </>
                      )
                    })}
                  </div>
                </RadioGroup>
              </div>
            </div>
          ) : null}

          <ul
            className={`grid gap-8 lg:gap-8 2xl:gap-12 ${
              type !== "featured"
                ? "md:col-span-2 lg:col-span-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4"
                : "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
            }`}
          >
            {posts?.map((post, postIndex) => {
              return (
                <>
                  {selected === "all" ||
                  post?.categories?.nodes?.find(checkCategory) ? (
                    <li
                      key={post}
                      className={`max-w-xs sm:max-w-none ${
                        type === "featured" && postIndex === 3
                          ? "hidden sm:block lg:hidden xl:block"
                          : ""
                      }`}
                    >
                      <NewsCard props={post} />
                    </li>
                  ) : null}
                </>
              )
            })}
          </ul>
        </div>
        {type === "featured" && link ? (
          <div>
            <Link to={link.url} target={link.target} className="btn btn-blue">
              {link.title}
            </Link>
          </div>
        ) : null}
      </div>
    </section>
  )
}
function RadioGroupOption(categories, hasParent) {
  return (
    <div
      className={`${
        hasParent ? "space-y-1.5 ml-2 border-l-4 border-l-blue-700 pl-2" : ""
      }`}
    >
      {categories.map(category => (
        <RadioGroup.Option
          key={category.name}
          value={category.slug}
          className={({ active, checked }) => `hover-grow ${
            active
              ? "ring-2 ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-700/50"
              : ""
          }
                  ${checked ? "bg-blue-700 text-white" : "bg-white "} ${
            hasParent ? "text-sm" : ""
          }
                    relative flex cursor-pointer rounded-lg leading-tight px-4 shadow-md focus:outline-none hover-grow`}
        >
          {({ active, checked }) => (
            <>
              <div className="flex w-full items-center justify-between">
                <div className="flex items-center">
                  <div className="py-3">
                    <RadioGroup.Label
                      as="p"
                      // className={` ${checked ? "text-white" : "text-gray-900"}`}
                    >
                      {category.name}
                    </RadioGroup.Label>
                  </div>
                </div>
                {checked && (
                  <div className="shrink-0 text-white">
                    <CheckIcon className="h-6 w-6" />
                  </div>
                )}
              </div>
            </>
          )}
        </RadioGroup.Option>
      ))}
    </div>
  )
}

function CheckIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx={12} cy={12} r={12} fill="#fff" opacity="0.2" />
      <path
        d="M7 13l3 3 7-7"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default NewsArchive
